import React ,{Component } from 'react';

import { certrequestActions,alertActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";
import ExcelReport from '../views/excelreport';

class ExcelReportContainer extends Component {
    constructor(props) {
        super(props);
        
        this.submit = this.submit.bind(this);
    }
    
    submit(event) {

        event.preventDefault();
        let data = this.refs.child.getData();
        const { dispatch } = this.props;
        console.log('data',data);
        
        dispatch(certrequestActions.getblob('CertificationRequest','ExportExcel','fromDate=' +  data.fromDate+'&toDate='+ data.toDate ))

        //console.log(data);
    
    }

    componentDidMount(){
       
        const { dispatch,match } = this.props;   
      


    //    const {patientId}=this.props.match.params;
    //    // console.log('Props',this.props);
    //    const { dispatch } = this.props;   
       
    //      if (patientId) {

    //         let id = patientId;
             
    //         dispatch(messageActions.get(id));
            
           
        
    //     } 
    }

    render() { 

        const { type,obj,error } = this.props;
        console.log('error',error)
        //console.log('TYPE',type);
        if(type==objConstants.ADD_SUCCESS)
        {
            //console.log('Added successfully');
          //  history.push('/message/inbox')
        }
        if(type==objConstants.UPDATE_SUCCESS)
        {
           // console.log('Updated successfully');
          //  history.push('/message/inbox')
        }
    
        return (
            
                <ExcelReport submitHandler={this.submit}   {...this.props}  ref="child" />
        );
       
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items,error } = state.objs;
   
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items,
        error      
    };
} 

export default withRouter(connect(mapStateToProps)(ExcelReportContainer));